/* globals Union */

import './lib/jquery';
import './lib/moment';
import './lib/react';
import './lib/router';
import Rails from 'rails-ujs';
import tippy from 'tippy.js';
import './lib/chartjs';

// Uncomment in order to start tracking client-side javascript events via Ahoy
// import ahoy from 'ahoy.js';

import 'cocoon';

import setupWizard from './form_step';
import openExternalLinksInNewtab from './external_links';
import imagePreview from './image_preview';
import loadResponsiveTables from './responsive_tables';
import axios from './lib/axios';
import UnionJsFramework from './union_js_framework';

// Expose components that are manually rendered in the views
window.axios = axios;
window.NotificationsListItem = require('./components/NotificationsListItem').default;
window.AnnouncementDetails = require('./components/AnnouncementDetails').default;
window.DateTimeInput = require('./components/DateTimeInput').default;
window.EventCard = require('./components/EventCard').default;

// Expose methods that are used in the views
window.Union = {
  Rails,
  setupWizard,
  imagePreview,
  loadResponsiveTables,
  initializeTippy() {
    tippy('[data-tooltip]', {
      arrow: true,
      inertia: true,
      animation: 'scale',
      content(reference) {
        const title = reference.getAttribute('title');
        reference.removeAttribute('title');
        return title;
      },
    });
  },
  log() {}, // Override this method for more debugging messages (eg: `Union.log = console.log`)
  ...UnionJsFramework,
};

Rails.start();
Union.start();

(function () {
  $(document).ajaxSuccess(Union.update);
  $(document).on('cocoon:after-insert', Union.update);

  // All elements with this data attribute will toggle associated content on click
  // The value of the data "toggable" attribute will be used to select the element
  $(document).on('click', '[data-toggable]', function () {
    $($(this).data('toggable')).toggle();
  });

  // New tabs created to replace foundation's
  $(document).on('click', '[data-union-tabs] a', function (e) {
    const selectedTab = $(this).attr('href');
    e.preventDefault();

    $('.union-tab-content').removeClass('u-block');
    $('.union-tab-anchor').removeClass('is-active');
    $(`${selectedTab}`).addClass('u-block');
    $(`a[href="${selectedTab}"]`).parent().addClass('is-active');

    if (history.pushState) {
      history.pushState(null, null, selectedTab);
    } else {
      location.hash = selectedTab;
    }
  });

  $(document).on('click', 'a[data-popup]', function (e) {
    window.open($(this).attr('href'), 'slack-oauth-popup', 'height=600, width=600');
    e.preventDefault();
  });

  $(document).on('change', '.uploadBox input[type=file]', function (e) {
    const $uploadBox = $(e.target).parents('.uploadBox');
    Union.imagePreview(this, $uploadBox.find('img'));
    $uploadBox.find('.uploadBox-message').show();
  });

  $(() => {
    if (window.location.hash && $('[data-union-tabs] a').length) {
      $('.union-tab-content').removeClass('u-block');
      $('.union-tab-anchor').removeClass('is-active');
      $(`a[href="${window.location.hash}"]`).parent().addClass('is-active');
      $(`${window.location.hash}`).addClass('u-block');
    }

    Union.initializeTippy();
  });

  // Open external links in a new tab
  openExternalLinksInNewtab();
}());
